import { LogoGithub } from "components/icons/generated";
import setLocation from "shared/setLocation";
import { FederationProvider } from "types/generated";

import ConnectionCard from "../ConnectionCard";
import { PersonalConnectionsFederation } from "../gql";
import useExternalAccountsConnectionFeedback from "../useConnectionFeedback";
import {
  GITHUB_LINK_ERROR_MESSAGES,
  GITHUB_LINK_GENERIC_ERROR,
  GITHUB_LINK_START_PATH,
} from "./constants";

const GITHUB_DESCRIPTION =
  "Connect your GitHub account to attribute commits and pull requests to your Spacelift activity.";

type ExternalAccountsGitHubCardProps = {
  federation?: PersonalConnectionsFederation;
};

const ExternalAccountsGitHubCard = ({ federation }: ExternalAccountsGitHubCardProps) => {
  const { errorMessage } = useExternalAccountsConnectionFeedback({
    statusParam: "github_link",
    errorParam: "github_link_error",
    successMessage: "GitHub successfully linked.",
    errorMessages: GITHUB_LINK_ERROR_MESSAGES,
    genericError: GITHUB_LINK_GENERIC_ERROR,
  });

  return (
    <ConnectionCard
      icon={LogoGithub}
      name="GitHub"
      provider={FederationProvider.GithubOauth}
      description={GITHUB_DESCRIPTION}
      federation={federation}
      onConnect={() => setLocation(GITHUB_LINK_START_PATH)}
      errorMessage={errorMessage}
    />
  );
};

export default ExternalAccountsGitHubCard;
